import { Factory, Ship } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { DeliveryMethod } from '~/graphql/graphql';
import { RESPONSIBILITY, type Responsibility } from '~/utils/deliveryMethod';

const SELLER_CLASS = 'bg-responsibility-seller';
const BUYER_CLASS = 'bg-responsibility-buyer';

const segClass = (r: Responsibility) =>
  r === 'seller' ? SELLER_CLASS : BUYER_CLASS;

const NODES = [
  { key: 'mill', Icon: Factory },
  { key: 'port_origin', Icon: Ship },
  { key: 'port_destination', Icon: Ship },
  { key: 'door', Icon: Factory },
] as const;

export function DeliveryJourneyDiagram({
  method,
}: Readonly<{ method: DeliveryMethod }>) {
  const { t } = useTranslation('cart');
  const segments = RESPONSIBILITY[method];

  return (
    <div data-testid="delivery-journey-diagram">
      <div className="flex items-center">
        {NODES.map((node, index) => (
          <div key={node.key} className="contents">
            <div className="flex flex-col items-center shrink-0">
              <div className="w-7 h-7 rounded-full bg-neut-100 border border-neut-300 flex items-center justify-center">
                <node.Icon className="w-3.5 h-3.5 text-neut-600" />
              </div>
              <span className="text-[9px] text-neut-500 mt-1">
                {t(`cart.international.journey.${node.key}`)}
              </span>
            </div>
            {index < segments.length && (
              <div
                data-testid={`journey-segment-${index}`}
                data-responsibility={segments[index]}
                className={`flex-1 h-1.5 rounded-full mx-1 ${segClass(segments[index])}`}
              />
            )}
          </div>
        ))}
      </div>
      <div className="flex items-center gap-3 mt-2.5">
        <div className="flex items-center gap-1">
          <span className={`w-2 h-2 rounded-full shrink-0 ${SELLER_CLASS}`} />
          <span className="text-[10px] text-neut-500">
            {t('cart.international.seller_responsible')}
          </span>
        </div>
        <div className="flex items-center gap-1">
          <span className={`w-2 h-2 rounded-full shrink-0 ${BUYER_CLASS}`} />
          <span className="text-[10px] text-neut-500">
            {t('cart.international.buyer_responsible')}
          </span>
        </div>
      </div>
    </div>
  );
}
